// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__kB0bU","title":"style_title__uPFvY","terms":"style_terms__sAazq","button":"style_button__VaS6i"};